import { SettleClosedPickDirective } from 'src/app/shared/directives/settle-closed-pick.directive';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { AppNumberInputDirective } from 'src/app/shared/directives/number-input.directive';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import { AppDatePipe } from 'src/app/shared/pipes/app-date.pipe';
import { AppCurrencyPipe } from 'src/app/shared/pipes/app-currency.pipe';
import { SortHeaderComponent } from 'src/app/shared/components/sort-header/sort-header.component';
import { AppImageUrlPipe } from 'src/app/shared/pipes/app-image-url.pipe';
import { ActionHostDirective } from './directives/action-host.directive';
import { ColumnHostDirective } from './directives/column-host.directive';
import { TableComponent } from './components/table/table/table.component';
import { ContextService } from './services/context.service';
import { ErrorHandlerService } from './services/error-handler.service';
import { QuotaDiagReporterService } from './services/quota-diag-reporter.service';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { ColumnComponent } from './components/table/column/column.component';
import { ActionComponent } from './components/table/action/action.component';
import { DefaultColumnComponent } from './components/table/column-impl/default-column/default-column.component';
import { DefaultCheckColumnComponent } from './components/table/column-impl/default-check-column/default-check-column.component';
import { DefaultCurrencyColumnComponent } from './components/table/column-impl/default-currency-column/default-currency-column.component';
import { DefaultDateColumnComponent } from './components/table/column-impl/default-date-column/default-date-column.component';
import { DefaultImageColumnComponent } from './components/table/column-impl/default-image-column/default-image-column.component';
import { DefaultSearchHeaderComponent } from './components/default-search-header/default-search-header.component';
import { DefaultListComponent } from './components/default-list/default-list.component';
import { DefaultSelectComponent } from './components/default-select/default-select.component';
import {OverlayModule} from '@angular/cdk/overlay';
import { DialogRowComponent } from './components/table/dialogs/dialog-row/dialog-row.component';
import { DefaultLinkToIdColumnComponent } from './components/table/column-impl/default-link-to-id-column/default-link-to-id-column.component';
import {
  DialogLoadSetInsertComponent,
  DraftPreviewDialogComponent,
  TableEditRowsComponent
} from './components/table/table-edit-rows/table-edit-rows.component';
import { StructureRapidLookUpFieldNormalComponent } from './components/table/column-impl/structure-rapid-look-up-field-normal/structure-rapid-look-up-field-normal.component';
import { DefaultSearchHeaderCodeComponent } from './components/default-search-header-code/default-search-header-code.component';
import { NgxUiLoaderConfig, SPINNER, PB_DIRECTION, POSITION, NgxUiLoaderModule } from 'ngx-ui-loader';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { DefaultSelectAllButtonComponent } from './components/default-select-all-button/default-select-all-button.component';
import {NgxSyncScrollModule} from "ngx-syncscroll";
import { AppUpdateBannerComponent } from './components/app-update-banner/app-update-banner.component';
import { CellCopyDirective } from 'src/app/shared/directives/cell-copy.directive';



const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  fgsColor: 'yellow',
  fgsType: SPINNER.threeStrings, // foreground spinner type
  pbDirection: PB_DIRECTION.leftToRight, // progress bar direction
  pbThickness: 3, // progress bar thickness
  pbColor: 'yellow',
  delay: 0,
  blur: 0,
  hasProgressBar: true, // Valutare di rimuovere la prima barra
  maxTime: -1,
  minTime: 300,
  bgsColor: 'yellow',
  bgsOpacity: 1,
  bgsPosition: POSITION.centerCenter,
  bgsSize: 80,
  fgsSize: 100,
  fgsPosition: POSITION.centerCenter,
  bgsType: SPINNER.threeStrings
};




@NgModule({
  declarations: [


    ColumnComponent,
    ActionComponent,
    ActionHostDirective,
    ColumnHostDirective,
    TableComponent,
    DefaultColumnComponent,
    DefaultCheckColumnComponent,
    DefaultCurrencyColumnComponent,
    DefaultDateColumnComponent,
    DefaultImageColumnComponent,
    DefaultListComponent,
    DefaultSelectComponent,
    DialogRowComponent,
    DefaultLinkToIdColumnComponent,
    TableEditRowsComponent,
    StructureRapidLookUpFieldNormalComponent,
    DialogLoadSetInsertComponent,
    DraftPreviewDialogComponent,
    DefaultSelectAllButtonComponent,
    AppUpdateBannerComponent,

  ],
  imports: [
    SettleClosedPickDirective,
    NgOptimizedImage,
    OverlayModule,
    NgxMatSelectSearchModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    CommonModule,
    SharedModule,
    TranslateModule.forChild(),
    FormsModule,
    AppNumberInputDirective,
    NgxSyncScrollModule,
    AppDatePipe,
    CellCopyDirective,
    AppCurrencyPipe,
    AppImageUrlPipe,
    SortHeaderComponent,
  ],
    exports: [
        TableComponent,
        TableEditRowsComponent,
        DefaultSelectComponent,
        DefaultListComponent,
        ColumnComponent,
        DefaultCurrencyColumnComponent,
        AppUpdateBannerComponent
    ],
  providers: [
    // { provide: LOCALE_ID, useValue: 'it' },
    ContextService,
    {
      // QuotaDiagReporterService is listed as a dependency purely to force its construction at
      // boot: it registers the storage-failure sink in its constructor, and a tree-shakeable
      // `providedIn: 'root'` service that nothing injects is never instantiated -- the probe would
      // silently observe nothing. It must be up before the first dispatch, since the persistence
      // metareducer writes on every action and the earliest failures are the boot ones.
      provide: APP_INITIALIZER,
      useFactory: () => function() {
        return true;
      },
      deps: [ContextService, QuotaDiagReporterService],
      multi: true
    },
    {provide: ErrorHandler, useClass: ErrorHandlerService}
  ],
  // entryComponents: [DefaultColumnComponent, DefaultImageColumnComponent, DefaultSearchHeaderComponent, DefaultSearchHeaderCodeComponent, DefaultDateColumnComponent, DefaultCurrencyColumnComponent, ActionComponent]
})
export class CoreModule { }
